import { forwardRef } from 'react'

import { cn } from 'shared/utils'

import { Button, IButton } from './button'

export const GreenButton = forwardRef<HTMLButtonElement, IButton>(({ className, ...props }, ref) => {
  const buttonClass = cn(
    'bg-gradient-to-b from-btn-light-green to-btn-dark-green border-4 shadow-green border-btn-light-green',
    className
  )

  return <Button {...props} className={buttonClass} ref={ref} />
})

GreenButton.displayName = 'GreenButton'
